import DummyForm from "components/DummyForm";

const TestForm = () => {
  return <DummyForm />;
};

export default TestForm;
